
'use client';

import Image from 'next/image';
import { Instagram, Mail, Menu, X } from 'lucide-react';
import { useState } from 'react';

export function PhotoCentricHomepage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = (
    <>
      <a href="#" className="font-bold">
        Work
      </a>
      <a href="#" className="text-gray-600 hover:text-black">
        Journal
      </a>
      <a href="#" className="text-gray-600 hover:text-black">
        About
      </a>
      <a href="#" className="text-gray-600 hover:text-black">
        Contact
      </a>
    </>
  );

  return (
    <div className="bg-white text-black">
      <div className="md:hidden p-4 flex justify-between items-center border-b">
        <h1 className="text-2xl font-bold tracking-tighter">Jane Doe</h1>
        <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X/> : <Menu/>}
        </button>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 bg-white z-50 p-8 md:hidden">
             <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold tracking-tighter">Jane Doe</h1>
                <button onClick={() => setIsMenuOpen(false)}>
                    <X/>
                </button>
            </div>
             <nav className="mt-12 flex flex-col gap-6 text-2xl">
                {navLinks}
            </nav>
             <div className="absolute bottom-8 left-8 text-sm">
                <p className="text-gray-600">Based in London, UK</p>
                <div className="flex gap-4 mt-2">
                    <a href="#" className="text-gray-500 hover:text-black"><Instagram size={18} /></a>
                    <a href="#" className="text-gray-500 hover:text-black"><Mail size={18} /></a>
                </div>
                <p className="mt-6 text-gray-400">&copy; {new Date().getFullYear()} Jane Doe</p>
            </div>
        </div>
      )}


      <main className="grid grid-cols-1 md:grid-cols-12 min-h-screen">
        <aside className="hidden md:flex col-span-3 border-r border-gray-200 flex-col justify-between p-8">
          <div>
            <h1 className="text-3xl font-bold tracking-tighter">Jane Doe</h1>
            <p className="mt-1 text-gray-500">Documentary Photographer</p>
            <nav className="mt-12 flex flex-col gap-4 text-lg">
                {navLinks}
            </nav>
          </div>
          <div className="text-sm">
            <p className="text-gray-600">Based in London, UK</p>
            <div className="flex gap-4 mt-2">
              <a href="#" className="text-gray-500 hover:text-black">
                <Instagram size={18} />
              </a>
              <a href="#" className="text-gray-500 hover:text-black">
                <Mail size={18} />
              </a>
            </div>
            <p className="mt-6 text-gray-400">
              &copy; {new Date().getFullYear()} Jane Doe
            </p>
          </div>
        </aside>
        <div className="col-span-12 md:col-span-9">
          <div className="grid grid-cols-2 lg:grid-cols-3 h-full">
            <div className="relative group col-span-2 row-span-2 h-96 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo1/1200/1200"
                alt="A dramatic black and white portrait of an elderly man with deep wrinkles"
                fill
                className="object-cover"
                data-ai-hint="portrait elderly"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                <h3 className="text-white text-2xl font-bold">
                  Portraits of a Generation
                </h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo2/600/600"
                alt="A colorful, bustling street market in Marrakech"
                fill
                className="object-cover"
                data-ai-hint="street market"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">Market Colors</h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo3/600/600"
                alt="A lone figure walking on a vast, empty desert dune"
                fill
                className="object-cover"
                data-ai-hint="desert dune"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">Solitude</h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo4/600/600"
                alt="Children playing in the spray of a fire hydrant on a city street"
                fill
                className="object-cover"
                data-ai-hint="children playing"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">
                  Summer in the City
                </h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo5/600/600"
                alt="An industrial landscape with smokestacks against a sunset"
                fill
                className="object-cover"
                data-ai-hint="industrial landscape"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">
                  Industry's End
                </h3>
              </div>
            </div>
            <div className="relative group col-span-2 lg:col-span-1 h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo6/600/600"
                alt="A tight-knit fishing community mending nets by the sea"
                fill
                className="object-cover"
                data-ai-hint="fishing community"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">
                  The Net Menders
                </h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo7/600/600"
                alt="An old, weathered wooden door with intricate carvings"
                fill
                className="object-cover"
                data-ai-hint="weathered door"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">Passages</h3>
              </div>
            </div>
            <div className="relative group h-48 md:h-auto">
              <Image
                src="https://picsum.photos/seed/photo8/600/600"
                alt="A high-contrast photo of a subway station, with motion blur"
                fill
                className="object-cover"
                data-ai-hint="subway station"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <h3 className="text-white text-lg font-bold">Underground</h3>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
